import { withInstall } from '@vuemap/vue-amap-util'
import MapboxVectorTileLayer from './MapboxVectorTileLayer.vue'

export const ElAmapLayerMapboxVectorTile = withInstall(MapboxVectorTileLayer)
export default ElAmapLayerMapboxVectorTile
